import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from './FontIcon.module.scss';

const FontIcon = (props) => {
  const { icon = '', className, children, title } = props;

  if (icon.length > 0 && icon !== 'none') {
    return (
      <>
        <span aria-hidden className={classNames(icon, className)} suppressHydrationWarning>
          {children}
        </span>
        {title && <span className={classes.hidden}>{title}</span>}
      </>
    );
  }

  return null;
};

FontIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FontIcon;
